import { apiService } from '@/services/APIService';

export default {

  createJournal(params) {
    return apiService.post('/poll-journals', params);
  },

  getJournals(params) {
    return apiService.get('/poll-journals', params);
  },

  showJournal(id, params) {
    return apiService.get(`/poll-journals/${id}`, params);
  },

  getJournalQuestions(id, params) {
    return apiService.get(`/poll-journals/${id}/questions`, params);
  },

  updateJournal(id, params) {
    return apiService.put(`/poll-journals/${id}`, params);
  },

  massSaveFakeJournals(data) {
    return apiService.post(`/poll-journals/fake/mass-save`, data);
  },
};
